module.exports = __webpack_public_path__ + "phone.6f96cf39b43ae28a9a2ce0baaab85840.png";